<script setup lang="ts">
const props = defineProps({
  price: {
    type: Number,
  },
});

const getPrice = computed(() => getFormattedPrice(props.price));
</script>

<template>
  <span>{{ getPrice }}</span>
</template>
